import { s } from "../../../utilities/common"

export const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={s("144")}
    height={s("144")}
    viewBox="0 0 144 144"
    fill="none"
  >
    <path
      d="M52.5046 97.2616L46.2646 90.7816L67.2646 70.6216V22.9216H76.2646V74.4616L52.5046 97.2616Z"
      fill="white"
    />
    <path
      opacity="0.8"
      d="M21.1172 122.94C11.0401 112.874 4.17475 100.045 1.39001 86.0768C-1.39473 72.1083 0.026157 57.6277 5.4729 44.4669C10.9196 31.3061 20.1476 20.0564 31.9891 12.1412C43.8307 4.22592 57.7537 0.000664822 71.9971 0V9C63.7238 9 55.5317 10.6296 47.8882 13.7956C40.2447 16.9617 33.2995 21.6022 27.4494 27.4523C21.5993 33.3024 16.9589 40.2474 13.7928 47.891C10.6268 55.5345 8.99713 63.7267 8.99713 72C8.99713 80.2733 10.6268 88.4655 13.7928 96.109C16.9589 103.753 21.5993 110.698 27.4494 116.548C33.2995 122.398 40.2447 127.038 47.8882 130.204C55.5317 133.37 63.7238 135 71.9971 135V144C52.9166 143.999 34.6167 136.425 21.1172 122.94Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M72 144V135C80.2733 135 88.4656 133.37 96.1091 130.204C103.753 127.038 110.698 122.398 116.548 116.548C122.398 110.698 127.038 103.753 130.204 96.109C133.371 88.4655 135 80.2733 135 72C135 63.7267 133.371 55.5345 130.204 47.891C127.038 40.2474 122.398 33.3024 116.548 27.4523C110.698 21.6022 103.753 16.9617 96.1091 13.7956C88.4656 10.6296 80.2733 9 72 9V0C91.0956 0 109.409 7.58573 122.912 21.0883C136.414 34.591 144 52.9044 144 72C144 91.0956 136.414 109.409 122.912 122.912C109.409 136.414 91.0956 144 72 144Z"
      fill="white"
    />
  </svg>
)
